import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col, Card } from 'reactstrap';
import { dataLoading } from '../../reducers/OpportunitiesReducer/OpportunitiesActions';
import useMarketingCampaigns from './useMarketingCampaigns';
import OpportunitiesTables from '../Opportunities/OpportunitiesTables';
import useOpportunities from '../Opportunities/useOpportunities';
import MarketingCampaignsOverview from './MarketingCampaignsOverview';
import MarketingCampaignsStatus from './MarketingCampaignsStatus';
import PageHeader from '../../sharedComponents/Header/PageHeader';
import { BsFillGridFill } from 'react-icons/bs';
import MobileMenuSlideDrawer from '../../sharedComponents/SlideDrawer/MobileMenuSlideDrawer';

const MarketingCampaigns = () => {
    const dispatch = useDispatch;
    dispatch(dataLoading);
    const { handleClickOverviewNav, handleClickStatusNav,setCampaignManagementTab } = useMarketingCampaigns.useMarketingCampaigns();
    const isLoading = useSelector(({marketing}) => marketing.isLoading);
    const { setAllFilters } = useOpportunities.useOpportunities();
    const tabOverview = useSelector(({ui}) => ui.oppsOverviewTab);
    const tabStatus = useSelector(({ui}) => ui.oppsStatusTab);
    const cmLinkSelectedClass = localStorage.getItem('branding') === "ARROWSTREAM" ? 'asCmLinkSelected' : 'cmLinkSelected';

    const initializePage = () => {
        setAllFilters();
        setCampaignManagementTab();
    };

    // eslint-disable-next-line
    useEffect(initializePage, []);

    if (isLoading) {
        return (
            <>
                <PageHeader title='Dashboard' subtitle="Campaign Management" icon={<BsFillGridFill fill='url(#icon-gradient)'/>}/>
                <Col className='p-3'>
                    <OpportunitiesTables />
                    <Row className="px-3">
                        <Card className="dashboard-card pt-3" style={{minHeight: '520px'}}>
                            <Row className='mx-0 mb-2' style={{borderBottom: '4px solid lightgray'}}>
                                <Container id='subheader-container' className='align-items-left' fluid>
                                    <Row className='clickable align-items-left'>
                                        <Col className={'campaignManagementLink w-fc position-relative h-100 pb-1 ' + (tabOverview ? 'text-black' : 'text-gray')} id={tabOverview ? cmLinkSelectedClass : ''} onClick={() => handleClickOverviewNav()}>
                                            <span className='campaign-management-nav-label'>CAMPAIGN OVERVIEW</span>
                                        </Col>
                                        <Col className={'campaignManagementLink w-fc position-relative h-100 pb-1 ' + (tabStatus ? 'text-black' : 'text-gray')} id={tabStatus ? cmLinkSelectedClass : ''} onClick={() => handleClickStatusNav()}>
                                            <span className='campaign-management-nav-label'>OPPORTUNITY STATUS</span>
                                        </Col>
                                    </Row>
                                </Container>
                            </Row>
                            { tabOverview &&
                                <MarketingCampaignsOverview />
                            }
                            { tabStatus &&
                                <MarketingCampaignsStatus />
                            }
                        </Card>
                    </Row>
                </Col>
                <MobileMenuSlideDrawer />
            </>
        );
    }
    return (
        <>
            <PageHeader title='Dashboard' subtitle="Campaign Management" icon={<BsFillGridFill fill='url(#icon-gradient)'/>}/>
            <Col className='pt-3 mx-0 marketingCampaignsContainer'>
                <OpportunitiesTables />
                <Row className="px-3">
                    <Card className="dashboard-card pt-3" style={{minHeight: '520px'}}>
                        <Row className='mx-0 mb-2' style={{borderBottom: '4px solid lightgray'}}>
                            <Container id='subheader-container' className='align-items-left' fluid>
                                <Row className='clickable align-items-left'>
                                    <Col className={'campaignManagementLink w-fc position-relative h-100 pb-1 ' + (tabOverview ? 'text-black' : 'text-gray')} id={tabOverview ? cmLinkSelectedClass : ''} onClick={() => handleClickOverviewNav()}>
                                        <span className='campaign-management-nav-label'>CAMPAIGN OVERVIEW</span>
                                    </Col>
                                    <Col className={'campaignManagementLink w-fc position-relative h-100 pb-1 ' + (tabStatus ? 'text-black' : 'text-gray')} id={tabStatus ? cmLinkSelectedClass : ''} onClick={() => handleClickStatusNav()}>
                                        <span className='campaign-management-nav-label'>OPPORTUNITY STATUS</span>
                                    </Col>
                                </Row>
                            </Container>
                        </Row>
                        {tabOverview &&
                            <MarketingCampaignsOverview />
                        }
                        { tabStatus &&
                            <MarketingCampaignsStatus />
                        }
                    </Card>
                </Row>
            </Col>
            <MobileMenuSlideDrawer />
        </>
    );
}

export default MarketingCampaigns;